import { Grid, Spacer, Text, useDialog } from "@holta/ui";
import { saveCustomer } from "../../../actions/editCustomer";
import { usePath } from "raviger";
import React from "react";

import { useIsEdited } from "../hooks/useIsEdited";
import { useMergedCustomer } from "../hooks/useMergedCustomerValues";

interface Props {}

export const Header: React.FC<Props> = () => {
    const path = usePath();
    const isEdited = useIsEdited();
    const customer = useMergedCustomer();
    const {openGenericDialog} = useDialog();

    const wrappedSaveCustomer = () => {
        saveCustomer().catch(e => {
            console.log(e)
            openGenericDialog(e.message, 'An Error Occurred');
        });
    };

    return (
        <Spacer xs={[2]}>
            <Grid.Row xs={{ justify: "space-between", align: "center" }}>
                <Grid.Col>
                    <Grid.Row xs={{ align: "center" }}>
                        <Text size="xl">Customer</Text>&nbsp;→&nbsp;
                        <Text size="xl" color="highlight">
                            {path === "/customers/new" ? "New" : customer?.name}
                        </Text>
                    </Grid.Row>
                </Grid.Col>
                <Grid.Col>
                    {isEdited && (
                        <button className="primary" onClick={wrappedSaveCustomer}>
                            Save
                        </button>
                    )}
                </Grid.Col>
            </Grid.Row>
        </Spacer>
    );
};
